import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=47f9a2a9&scoped=true&"
import script from "./InputRadio.vue?vue&type=script&lang=ts&"
export * from "./InputRadio.vue?vue&type=script&lang=ts&"
import style0 from "./InputRadio.vue?vue&type=style&index=0&id=47f9a2a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f9a2a9",
  null
  
)

export default component.exports